export const QUERY = `
  query JWMCalendarUnscheduledItemsCount($cloudId: ID!, $jql: String!) {
    jira {
      unscheduledCount: jwmViewItems(cloudId: $cloudId, jql: $jql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
    }
  }
`;
